<ng-container [formGroup]="parentForm">
	
    <ng-container *ngFor="let question of qQuestions;let i=index"> 
        
        <!-- Question Row -->
        <tr>
            
            <ng-template #notRequired>
                <td width="5%">&nbsp;</td>
            </ng-template>
            <ng-container *ngIf="!question?.dependency;else dependency" class="boldlbl">
                <td width="70%" colspan="2">
                    <p class="boldlbl">
                        <ng-container *ngIf="DispSeqInd === 'Y'">
                            <ng-container *ngIf="DispSeqType === 'A'; else dispSeqTypeN">
                                <!-- Display sequence as alphabets-->
                                {{getTRCAlphaList(i)}}.&nbsp;&nbsp;
                            </ng-container>
                            <ng-template #dispSeqTypeN>
                                <!-- Display sequence as numbers-->
                                {{i+1}}.&nbsp;&nbsp;
                            </ng-template>
                        </ng-container>
                        {{question?.questionTxt}}
        				
                    </p>
                </td>
            </ng-container>
            <ng-template #dependency>
                <td width="5%">&nbsp;</td>
                <td width="65%" style="vertical-align:top;">
                    <p >
                        >&nbsp;&nbsp;<strong>{{question?.questionTxt}}</strong>
                    </p>
                </td>
            </ng-template>
            <!-- answer section -->
            <td class="label1" nowrap="nowrap" style="vertical-align:top;">
                <!-- display answers only -->
                <ng-container *ngIf="DispOnlyInd === 'Y';else notDisplayOnly">
                    <span style="text-decoration:underline">
                        <ng-container [ngSwitch]="question.questionType">
                            <span *ngSwitchCase="'YES/NO'" class="boldlbl">
                                <ng-container [ngSwitch]="question.answerTxt">
                                    <span *ngSwitchCase="'Y'">
                                        YES
                                    </span>
                                    <span *ngSwitchCase="'N'">
                                        NO
                                    </span>
                                    <span *ngSwitchDefault>
                                        ---
                                    </span>
                                </ng-container>
                            </span>
                            <span *ngSwitchCase="'YES/NO/N/A'" class="boldlbl">
                                <ng-container [ngSwitch]="question.answerTxt">
                                    <span *ngSwitchCase="'Y'">
                                        YES
                                    </span>
                                    <span *ngSwitchCase="'N'">
                                        NO
                                    </span>
                                    <span *ngSwitchCase="'N/A'">
                                        N/A
                                    </span>
                                    <span *ngSwitchDefault>
                                        ---
                                    </span>
                                </ng-container>
                            </span>
                            <span *ngSwitchCase="'FREEFORM'">
                                <span *ngIf="question.answerTxt.length>0;else noFreeformTxt" class="boldlbl">{{question.answerTxt}}</span>
                                <ng-template #noFreeformTxt>---</ng-template>
                            </span>
                            <span *ngSwitchCase="'DATE'">
                                <span *ngIf="question.answerTxt.length>0" class="boldlbl">{{question.answerTxt}}</span>
                            </span>
                            <span *ngSwitchCase="'TEXTAREA'">
								
                            </span>
                        </ng-container>
                    </span>
                </ng-container>
                <ng-template #notDisplayOnly>
                    <ng-container *ngIf="question.questionType === 'YES/NO'">
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">Yes</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input" [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="Y"
                                [checked]="question.answerTxt === 'Y'"  (change)="isYes(question,$event)"  
                                />
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">No</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input" [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="N"
                                [checked]="question.answerTxt === 'N'" (change)="isYes(question,$event)"/> 
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'YES/NO/N/A'">
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">Yes</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input" [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="Y"
                                [checked]="question.answerTxt === 'Y'" (change)="isYes(question,$event)"/>
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">No</label>
                            &nbsp;&nbsp;<input type="radio" class="form-check-input" [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="N"
                                [checked]="question.answerTxt === 'N'" (change)="isYes(question,$event)"/>
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">N/A</label>
                            &nbsp;&nbsp;<input type="radio" class="form-check-input" [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="NA"
                                [checked]="question.answerTxt === 'NA'" (change)="isYes(question,$event)"/>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'FREEFORM'">
                        <div class="form-group">
                            <input type="text" [attr.name]="question.metaName" class="form-control form-control-sm "
                            formControlName="{{question.metaName}}" value=""
                            [maxlength]="question.textFieldMaxLength" />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'RADIOSELECT' ">
                        <div class="form-check-inline">
                            <input type="radio"  name="question.metaName" class="form-check-input" [attr.disabled]="disabledValue ? '' : null"
                            formControlName="{{question.metaName}}" value="Y" style="height:13px; position:absolute;width:270px" (change)="isFTYes(question,$event)" (change)="data1()"
                             />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'TEXT' ">
                        <div>
                            <p class="boldlbl">{{question?.questionTxt | uppercase}}</p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'DATE'">
                        <input type="date" [attr.name]="'dt'+question.metaName" maxlength="10"
                            class="form-control form-control-sm" formControlName="dt{{question.metaName}}"
                            [maxlength]="question.textFieldMaxLength" value="" />
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'TEXTAREA'">
                        <!-- if textarea display it in next row -->
                    </ng-container>
                </ng-template>
            </td>
        </tr>
        <tr>
        <ng-container *ngIf="question?.notes?.length > 0 && DispOnlyInd === 'N'">
            
                <td style="background-color: #bfe0ff" colspan="3" width="100%">{{question?.notes}}<br> <br>{{question?.additionalComm}}<a href="{{question?.urlLink}}" target="_blank">{{question?.linkTxt}}</a></td>
            	
        </ng-container>
        </tr>
<tr *ngIf="question.questionType === 'TEXTAREA'">
            <td width="5%">&nbsp;</td>
            <ng-container>
                <ng-container *ngIf="question?.dependency !== 0">
                    <td width="5%">&nbsp;</td>
                </ng-container>
                <td [attr.colspan]="question?.dependency === 0?2:1"
                    [ngClass]="{'w-70': question?.dependency === 0, 'w-65' : question?.dependency !== 0 }">
                    <ng-container *ngIf="DispOnlyInd === 'Y';else notDisplayOnly">
                        <textarea cols="50" class="form-control form-control-sm" rows="3"
                            readonly="readonly">{{question.answerTxt}}</textarea>
                    </ng-container>
                    <ng-template #notDisplayOnly>
                        <textarea cols="50" [attr.name]="question.metaName" class="form-control form-control-sm"
                            formControlName="{{question.metaName}}" rows="3"
                            [maxlength]="question.textFieldMaxLength">{{question.answerTxt}}</textarea>
                        <span style="font-size:10px; font-style:italic">You have {{
                            parentForm.get(question.metaName).value | remainingTextCounter:
                            question.textFieldMaxLength}} characters remaining
                            for your entry.</span>
                    </ng-template>
                </td>
                <td>
                    <p></p>
                </td>
            </ng-container>
        </tr>
        <tr *ngIf="isSelected && question.answerTxt === 'Y' && isNextlevel && ( question.childQuestions && question.childQuestions.length)" class="table table-no-border" id="level2_table" style="width: 100%;">
        <td width="5%"></td>
        <td width="70%" colspan="2" >
       
       
									</td>
	</tr>
        <ng-container
            *ngIf="parentForm.get(question.metaName)?.invalid && parentForm.get(question.metaName)?.touched && question.metaName === 'SSN'">
            <tr>
                <td colspan="4">
                    <span class="errorMsg" *ngIf="parentForm.get(question.metaName)?.errors.ssnError">
                        Please correct Social Security Number (999-99-9999). Social Security Number must be
                        valid, and entered in the expected format (include dashes). For example, '000-00-0000'
                        (invalid number) or '123456789' (incorrect format) will not be accepted.
                    </span>
                    <span class="errorMsg" *ngIf="parentForm.get(question.metaName)?.errors.bothSsnFein">
                        Please do not provide both a Federal Employment Identification Number and a Social
                        Security Number. Only one is accepted.
                    </span>
                    <span class="errorMsg" *ngIf="parentForm.get(question.metaName)?.errors.oneOfSsnFein">
                        Please enter either the Federal Employment Identification Number (99-9999999), or the
                        Social Security Number (999-99-9999) of the business. Make sure the data is valid and in
                        the expected format.
                    </span>
                </td>
            </tr>
        </ng-container>
        <ng-container
            *ngIf="parentForm.get(question.metaName)?.invalid && parentForm.get(question.metaName)?.touched && question.metaName === 'FEIN'">
            <tr>
                <td colspan="4">
                    <span class="errorMsg" *ngIf="parentForm.get(question.metaName)?.errors.feinError">
                        Please correct Federal Employment Identification Number (99-9999999).
                    </span>
                </td>
            </tr>
            </ng-container>
</ng-container>
</ng-container>